export default "__VITE_ASSET__Bpuv9uti__"